const state = {
  video_url: "",
  column_type: false,
  fromid: -1,
  watched_num: 0,
  is_favorite: -1,
  is_watched: -1,
  is_watch: -1,
};
const mutations = {
  videoUrl(state, videoUrl) {
    state.video_url = videoUrl;
  },
  columnType(state, columnType) {
    state.column_type = columnType;
  },
  fromid(state, fromid) {
    state.fromid = fromid;
  },
  watched_num(state, watched_num) {
    state.watched_num = watched_num;
  },
  is_favorite(state, is_favorite) {
    state.is_favorite = is_favorite;
  },
  is_watched(state, is_watched) {
    state.is_watched = is_watched;
  },
  is_watch(state, is_watch) {
    state.is_watch = is_watch;
  },
};
const actions = {
  videoUrl: ({ commit }) => commit("videoUrl"),
  columnType: ({ commit }) => commit("columnType"),
  fromid: ({ commit }) => commit("fromid"),
  watched_num: ({ commit }) => commit("watched_num"),
  is_favorite: ({ commit }) => commit("is_favorite"),
  is_watched: ({ commit }) => commit("is_watched"),
  is_watch: ({ commit }) => commit("is_watch"),
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
